const mobileMenu = async function() {

    const toggleMenu = document.querySelector('.toggle-menu')
    const mobileMenu = document.querySelector('.mobile-menu')
    const headerLogo = document.querySelector('.header__logo')
    const headerLogoOpen = document.querySelector('.header__logo--open')

    const header = document.querySelector('.header')
    const toggleMobileMenu = () => {
        toggleMenu.classList.toggle('is-active')
        mobileMenu?.classList.toggle('is-active')
        document.body.classList.toggle('overflow-hidden')
        headerLogo.classList.toggle('opacity-0')
        headerLogoOpen.classList.toggle('opacity-0')
        if(toggleMenu.classList.contains('is-active')) {
            header.style.backgroundColor = '#1A1A1A'
            // setTimeout(() => {
            //     header.style.backgroundColor = '#1A1A1A'
            // }, 300);
        }
        else {
            header.style.backgroundColor = '#EBEBE7'

        }

    }
    toggleMenu?.addEventListener('click', toggleMobileMenu);
}

export const init = mobileMenu;